import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithRetry } from './baseQuery';

/**
 * `/auth/me` — identity + the user's display name. Display name is no longer a JWT
 * claim (the Foundation backend dropped the `name` claim); the backend returns it here,
 * decrypted from the Scribia user profile. Anything that shows the user's name reads it
 * from this query, not from `auth.user`.
 */
export interface MeDto {
  userId: string;
  email: string;
  displayName: string;
}

export const meApi = createApi({
  reducerPath: 'meApi',
  baseQuery: baseQueryWithRetry,
  endpoints: (builder) => ({
    getMe: builder.query<MeDto, void>({
      query: () => '/auth/me',
    }),
  }),
});

export const { useGetMeQuery } = meApi;
